import { FC, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { CommonWorkflowService } from '@savgroup-front-common/core/api';
import { AdditionalInformation } from '@savgroup-front-common/core/components/AdditionalInformationWithReactHookForm';
import { useUploadAttachmentsOnFile } from '@savgroup-front-common/core/hooks/useUploadAttachmentsOnFile';
import { Accordion } from '@savgroup-front-common/core/molecules/Accordion';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';

import useGetSellerConfiguration from '../../../../../app/hooks/useGetSellerConfiguration';
import { useFileFollowupsContext } from '../../FileFollowups.context';

import { AdaptedNeededInformation } from './AdditionalInformationExpect.types';

interface ProductAdditionalInformationProps {
  product: {
    neededInformation: AdaptedNeededInformation[];
    modelName?: string;
  };
}

const ProductAdditionalInformation: FC<ProductAdditionalInformationProps> = ({
  product,
}) => {
  const { fileId } = useParams() as { fileId: string };
  const formContext = useFormContext();
  const {
    formState: { errors },
  } = formContext;
  const errorsAddInformationIds = Object.keys(errors);

  const { fileSummary } = useFileFollowupsContext();
  const { sellerConfiguration: seller } = useGetSellerConfiguration({
    sellerId: fileSummary?.sellerId,
  });

  const [isOpen, setIsOpen] = useState(true);
  const isErrored = product.neededInformation
    .map((item) => item.id)
    .some((id) => errorsAddInformationIds.includes(id));

  const { handleUploadDocuments } = useUploadAttachmentsOnFile({
    fileId,
  });

  useEffect(() => {
    if (isErrored) {
      setIsOpen(true);
    }
  }, [isErrored]);

  if (!fileSummary) {
    return <BaseLoader />;
  }

  return (
    <Accordion
      isOpen={isOpen}
      onClick={() => setIsOpen(!isOpen)}
      title={product.modelName || '-'}
      isErrored={isErrored}
    >
      <AdditionalInformation
        ignoreUniquenessByProduct
        formContext={formContext}
        neededInformation={product.neededInformation as any}
        onNeedToUploadFileAttachements={handleUploadDocuments}
        sellerId={fileSummary.sellerId}
        getQrUploadLink={
          CommonWorkflowService.getFileAttachmentUploadLinkFromMyAccountCommand
        }
        fileReference={fileSummary.fileReference}
        currency={seller?.currency}
      />
    </Accordion>
  );
};

export default ProductAdditionalInformation;
